import { render, staticRenderFns } from "./Pantone.vue?vue&type=template&id=7fdc663b&scoped=true"
import script from "./Pantone.vue?vue&type=script&lang=js"
export * from "./Pantone.vue?vue&type=script&lang=js"
import style0 from "./Pantone.vue?vue&type=style&index=0&id=7fdc663b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdc663b",
  null
  
)

export default component.exports